function CollapseData(props) {
    const data = props?.data;
    return (
        <div className="container py-5">
            <div className="row">
                <div id="faqlist" className="accordion accordion-flush">
                    {
                        data && data.map((item, index) => (
                            <div className="accordion-item" key={index}>
                                <h2 className="accordion-header">
                                    <button className="btn accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#content-accordion-${index}`}>
                                        {index+1 + ". " + item?.question}
                                    </button>
                                </h2>
                                <div id={`content-accordion-${index}`} className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                    <p className="accordion-body" dangerouslySetInnerHTML={{ __html: item?.answer }}></p>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}
export default CollapseData;